import { useMedia } from 'react-use';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

const CANVAS_MIN_SCREEN_WIDTH = 1000;

/**
 * Returns whether the generative canvas panel should be shown.
 * Requires both the feature flag and a minimum screen width.
 */
export const useIsCanvasVisible = () => {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const isAboveCanvasMinScreen = useMedia(`(min-width: ${CANVAS_MIN_SCREEN_WIDTH}px)`, false);

  return generativeCanvasEnabled && isAboveCanvasMinScreen;
};

/**
 * Returns whether the canvas should render as a full-screen overlay.
 * True when the feature flag is on but the screen is too narrow for side-by-side.
 *
 * SSR default is `true` for `isAboveCanvasMinScreen` (i.e. assume wide screen),
 * which makes this hook return `false` on SSR — matching `useIsCanvasVisible`'s
 * SSR default of `false`. Both hooks start "off" until the media query resolves.
 */
export const useIsCanvasOverlayMode = () => {
  const { generativeCanvasEnabled } = useTemporaryFeatureFlags();
  const isAboveCanvasMinScreen = useMedia(`(min-width: ${CANVAS_MIN_SCREEN_WIDTH}px)`, true);

  return generativeCanvasEnabled && !isAboveCanvasMinScreen;
};
